import * as React from "react";
const IconCertificate = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56 34.8h-3.9V9.6c0-4.2-3.3-7.6-7.3-7.8H13.2C6.9 1.7 1.8 7 1.8 13.5v4.3c0 2 1.7 3.7 3.7 3.7H12v26.7c0 3.5 2.9 6.4 6.5 6.4h3.7v5.1c0 1 .5 1.8 1.4 2.3q.6.3 1.2.3c.5 0 1-.1 1.4-.4l4.6-3 4.5 2.9.2.1c.9.4 1.8.4 2.6-.1s1.2-1.3 1.2-2.2v-5H56c3.4 0 6.3-2.8 6.3-6.3V41c0-3.4-2.9-6.2-6.3-6.2M6.3 13.5c0-4 3.1-7.3 6.9-7.3h22.7c-.6 1.2-1 2.6-1 4.1V17H6.3zm24.4 31c-3.7 0-6.6-2.9-6.6-6.5s3-6.5 6.6-6.5 6.6 2.9 6.6 6.5-2.9 6.5-6.6 6.5m1.7 10.1c-1-.7-2.3-.7-3.4 0l-2.4 1.6v-8c1.3.5 2.7.8 4.1.8 1.5 0 2.9-.3 4.1-.8v8zm6.9-4.5v-5.2c1.6-1.9 2.5-4.3 2.5-6.9 0-6.1-5-11-11.1-11s-11.1 4.9-11.1 11c0 2.6.9 5.1 2.5 7v5.1h-3.7c-1.1 0-2-.8-2-1.9V21.5h19.2c2 0 3.7-1.7 3.7-3.7v-7.4c0-2.2 1.5-3.9 3.5-4.1h1.5c1.8 0 3.2 1.5 3.2 3.3v40.5zm18.5-1.8c0 1-.8 1.8-1.8 1.8h-3.9V39.3H56c1 0 1.8.8 1.8 1.8z" />
  </svg>
);
export default IconCertificate;
